import { render } from "./request-account-dialog.vue?vue&type=template&id=1683f730&scoped=true&ts=true"
import script from "./request-account-dialog.vue?vue&type=script&lang=ts"
export * from "./request-account-dialog.vue?vue&type=script&lang=ts"

import "./request-account-dialog.vue?vue&type=style&index=0&id=1683f730&scoped=true&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1683f730"]])

export default __exports__